import useRequest from '@/websdk/utils/request';
export default (function () {
  const { data, exec, isRequestSuccessed } = useRequest({
    name: 'GET_FREE_DEVICES',
    url: `/api/v1/worklines/free-devices`,
  });
  return [data || [], exec, isRequestSuccessed];
});
